// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import React from "react";

const LandingNavbar = () => {
  return <div></div>;
};

export default LandingNavbar;
